module.exports = __webpack_public_path__ + "mainCover.304120cf.jpg";